import { render } from "./AtomSelect.vue?vue&type=template&id=5bcf87f2"
import script from "./AtomSelect.vue?vue&type=script&lang=js"
export * from "./AtomSelect.vue?vue&type=script&lang=js"
script.render = render

export default script